import { render, staticRenderFns } from "./addContacts.vue?vue&type=template&id=c8eeed16&scoped=true"
import script from "./addContacts.vue?vue&type=script&lang=js"
export * from "./addContacts.vue?vue&type=script&lang=js"
import style0 from "./addContacts.vue?vue&type=style&index=0&id=c8eeed16&prod&lang=scss&scoped=true"
import style1 from "./addContacts.vue?vue&type=style&index=1&id=c8eeed16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8eeed16",
  null
  
)

export default component.exports